import chatVoiceFixture from './chat-voice';
import deepResearchFixture from './deep-research';
import documentReaderFixture from './document-reader';
import legalDraftFixture from './legal-draft';
import bilingualFlipFixture from './bilingual-flip';
import montageFixture from './montage';
import { ChatFixture } from './types';

export const journeyFixtures: Record<number, ChatFixture> = {
  1: chatVoiceFixture,
  2: deepResearchFixture,
  3: documentReaderFixture,
  4: legalDraftFixture,
  5: bilingualFlipFixture,
  6: chatVoiceFixture,
  7: montageFixture,
  8: montageFixture,
  9: montageFixture,
};

export const ALL_FIXTURES = [
  chatVoiceFixture,
  deepResearchFixture,
  documentReaderFixture,
  legalDraftFixture,
  bilingualFlipFixture,
  montageFixture,
];

export { chatVoiceFixture, deepResearchFixture, documentReaderFixture, legalDraftFixture, bilingualFlipFixture, montageFixture };
export * from './types';
